var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CALL_API } from '../../../middleware/api';
import * as ActionTypes from '../profile';
var fetchGambler = function () {
    var _a;
    return (_a = {
            type: ActionTypes.FETCH_GAMBLER
        },
        _a[CALL_API] = {
            endpoint: '/api/gambler',
            method: 'get',
            types: [ActionTypes.SUCCESS_FETCH_GAMBLER, ActionTypes.FAILURE_FETCH_GAMBLER],
            credentials: true
        },
        _a);
};
export function getGambler() {
    return function (dispatch) {
        return dispatch(fetchGambler());
    };
}
var fetchUpdateProfile = function (data) {
    var _a;
    return (_a = {
            type: ActionTypes.UPDATE_PROFILE_INFO
        },
        _a[CALL_API] = {
            endpoint: '/api/gambler',
            method: 'PATCH',
            types: [ActionTypes.SUCCESS_UPDATE_PROFILE_INFO, ActionTypes.FAILURE_UPDATE_PROFILE_INFO],
            credentials: true,
            data: data
        },
        _a);
};
export function checkPhone(data) {
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.CHECK_PHONE
            },
            _a[CALL_API] = {
                endpoint: '/join/check/phone',
                method: 'post',
                types: [ActionTypes.SUCCESS_CHECK_PHONE, ActionTypes.FAILURE_CHECK_PHONE],
                credentials: true,
                data: data
            },
            _a));
    };
}
export function updateProfile(data) {
    return function (dispatch) {
        delete data['gambler'];
        // if(data['Birthdate']) {
        //     data['Birthdate'] = moment(data['Birthdate'], "DD-MM-YYYY").format('YYYY-MM-DD')
        // }
        dispatch(fetchUpdateProfile(data));
    };
}
export function changePassword(values) {
    var data = __assign(__assign({}, values), { NewPassword: values.Password });
    delete data['Password'];
    return function (dispatch) {
        var _a;
        return dispatch((_a = {
                type: ActionTypes.CHANGE_PROFILE_PASSWORD
            },
            _a[CALL_API] = {
                endpoint: 'api/gambler/change-password',
                method: 'POST',
                types: [ActionTypes.CHANGE_PROFILE_PASSWORD_SUCCESS, ActionTypes.CHANGE_PROFILE_PASSWORD_FAILURE],
                credentials: true,
                data: data
            },
            _a));
    };
}



// WEBPACK FOOTER //
// ./src/actions/profile/creators/profile.js